module.exports = __webpack_public_path__ + "img/carstock.7b94855c.svg";